import {IHolidayCalendarData, IUpdateholidayCalendarData, UPDATE_HOLIDAY_CALENDAR} from './types';

export function updateHolidayCalendarDataAction(
  actionData: IHolidayCalendarData,
): IUpdateholidayCalendarData {
  return {
    type: UPDATE_HOLIDAY_CALENDAR,
    actionData,
  };
}
